import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../store/reducers/frasesConfirmacion/frasesConfirmacion.reducer";
import { getFraseConfirmacionByIdThunk } from "../../store/reducers/frasesConfirmacion/frasesConfirmacion.thunks";

const FraseConfirmacionActions = ({ frase }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    await dispatch(getFraseConfirmacionByIdThunk(frase.id));
    dispatch(
      openFormModal({
        mode: "edit",
      })
    );
  };

  const handleToggle = () => {
    dispatch(
      openConfirmToggle({
        id: frase.id,
      })
    );
  };

  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getFraseConfirmacionByIdThunk(frase.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${frase.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                frase.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{frase.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FraseConfirmacionActions;
